import { FaTrash } from "react-icons/fa";
import { useParams } from "react-router-dom";

import BackButton from "@Components/BackButton";
import Button from "@Components/Button";
import Grid from "@Components/Grid";
import IconButton from "@Components/IconButton";
import Paper from "@Components/Paper";
import useCurrentUser from "@Hooks/useCurrentUser";
import {
  useDeleteMember,
  useDisableMember,
  useGetMember,
  useUpdateMember,
} from "@Hooks/useUsers";
import { User as UserType } from "@Types/users";

import styles from "./User.module.scss";
import { UserForm } from "./UserForm";
import LoadingFullScreen from "@Components/Loading/LoadingFullScreen";

const User = () => {
  const { id } = useParams<{ id: string }>();
  if (!id) return <>Error</>;
  const { user } = useGetMember(id);
  const currentUser = useCurrentUser();
  const { updateUser } = useUpdateMember();
  const { deleteUser } = useDeleteMember();
  const { disableUser } = useDisableMember();

  const handleSaveChanges = (
    e: React.FormEvent<HTMLFormElement>,
    user: UserType | undefined
  ) => {
    e.preventDefault();

    if (user) updateUser(user);
  };

  const handleDisableUser = () => {
    if (user) disableUser(user);
  };

  return user ? (
    <Grid container xs={12} spacing={1} className={styles.container}>
      <Grid container xs={12}>
        <Grid xs={1.5}>
          <BackButton />
        </Grid>
        <Grid container xs={12}>
          <Grid xs={10} display="flex">
            <h2 className={styles.title}>Edit User</h2>
            {currentUser?.data.info.userType === "lender-admin" && (
              <div className={styles.deleteUser}>
                <Button
                  className={styles.disableUser}
                  onClick={handleDisableUser}
                >{`${
                  user.data.firebaseDisabled ? "Enable" : "Disable"
                } user`}</Button>
                <IconButton
                  onClick={() => deleteUser(user)}
                  flex
                  style={{ fontSize: "20px", flex: 1 }}
                >
                  Delete user
                  <FaTrash
                    style={{ marginLeft: 10 }}
                    size={20}
                    color="#eb8190"
                  />
                </IconButton>
              </div>
            )}
          </Grid>
        </Grid>

        <Grid container xs={10}>
          <Paper>
            <UserForm<UserType>
              id={user._id}
              type="update"
              emailDisabled={true}
              initialState={user}
              handleSubmit={handleSaveChanges}
            />
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  ) : (
    <LoadingFullScreen />
  );
};

export default User;
